<div class="sm-toasts">
    <div *ngFor="let toast of toasts" @verticalCollapse @triggerChildAnimation>
        <sm-toast 
            @slideUp
            @slideOut        
            [toast]="toast"
            (onClickLink)="onClickLink.emit($event)" 
            (dismiss)="dismiss($event)">
        </sm-toast>
    </div> 
</div>
